<template>
    <div class="container-md container-app p-0 ">
        <div class="wrapper">
            <div class="header"><h1>{{ $t('layout_opzioni_label_csconto_tooltip') }}</h1></div>
            <div class="content content-full">
                <div class="title">{{ $t('sconti.lista_title') }}</div>
                <hr>
                <div class="container p-4">
                    <div class="row pt-2">
                        <div class="col-md-6 col-lg-4 mb-3" v-for="coupon in this.discount_codes">
                            <div class="codici-sconto d-flex align-items-center">
                              <div class="vertical-line"></div>
                              <div class="p-3">
                                <p class="mt-1 mb-2"><b class="green f22"><i>{{ getCouponDiscount(coupon) }}</i></b></p>
                                <!-- if ordine minimo -->
                                <p v-if="coupon.ordine_minimo">
                                    {{ $t('sconti.ordine_minimo') }} {{
                                    coupon.ordine_minimo.toFixedGood(2)
                                  }} {{ locale_currency }}
                                </p>
                                <p v-if="!coupon.dal && !coupon.al">
                                    {{ $t('sempre_valido') }}
                                </p>
                                <p v-else-if="moment(coupon.dal).isSame(moment(coupon.al), 'day')">
                                    {{ $t('valido_il') }} {{ moment(coupon.dal).format('DD/MM') }}
                                </p>
                                <p v-else>
                                    {{ $t('valido_dal') }} {{ moment(coupon.dal).format('DD/MM') }}
                                    {{ $t('al') }} {{ moment(coupon.al).format('DD/MM') }}
                                </p>
                                <p class="f16 mt-3 mb-0 ellipsis">
                                  <b>{{ coupon.nome }}</b>
                                </p>
                                <div class="codici-sconto-dettaglio gray" v-if="!coupon.tipi_orario_completi">
                                  {{ $t('attivo_solo_per') }}: {{ getCouponTipiOrarioText(coupon) }}
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
              <div class="container d-none d-md-block">
                <hr>
                <div class="row-sezione d-flex justify-content-center">
                  <router-link :to="{name:'home'}">
                    <button type="button" class="btn btn-default">{{$t("btn_indietro")}}</button>
                  </router-link>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { getCoupons } from '../../api/account';

export default {
    data: function () {
        return {
            discount_codes: []
        }
    },
    created() {
        this.fetchCoupons();
    },
    computed: {
        ...mapState('localization', {
            language: (state) => state.language
        }),
        ...mapState('restaurant', {
            id_ristorante: (state) => state.id,
            locale: (state) => state.locale
        }),
        ...mapGetters('restaurant', {
            locale_currency: 'localeCurrency',
            getServiceInfo: 'serviceInfo'
        }),
        ...mapState('auth', {
            user: state => state
        }),
    },
    watch: {
        language: function () {
            this.fetchCoupons();
        }
    },
    methods: {
        fetchCoupons: function () {
            this.showLoading(true);
            getCoupons(this.language, {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id,
                api_key: this.user.api_key,
                f_nascosto: 0
            }).then((response) => {
                this.discount_codes = response.codici_sconto;
            }).catch(({messages}) => {
                alert(messages.join('\n'))
            }).finally(() => {
                this.showLoading(false);
            });
        },
        getCouponDiscount: function (coupon) {
            if (coupon.valore || !coupon.f_spedizione_gratis) {
                if (coupon.tipo === "VALORE") {
                    return this.$t('sconto') + ' ' + coupon.valore.toFixedGood(2) + ' ' + this.locale_currency;
                }

                return coupon.valore + '%';
            }

            if (!!coupon.f_spedizione_gratis) {
                return this.$t('spedizione_gratuita');
            }

            return null;
        },
        getCouponTipiOrarioText: function (coupon) {
            return coupon.tipi_orario.length ?
                coupon.tipi_orario.map(tipoOrario => this.getServiceInfo(tipoOrario.toUpperCase(), null).nome).join(" - ")
                :
                "N/A";
        },
        ...mapActions('global', [
            'showLoading'
        ])
    }
}
</script>
